import { Filters } from '@/types';

export namespace RetroBonuses {
  export enum Pages {
    RETRO_BONUSES = 'retro_bonuses',
    RETRO_BONUSES_REWARD_DOCUMENTS = 'reward_documents',
    RETRO_BONUSES_REWARD_DOCUMENT = 'reward_document'
  }

  export interface RetroBonus {
    [key: string]: unknown,
    contract_name: string,
    contract_number: string,
    date: string,
    name_organization: string,
    id: number,
  }

  export interface RewardDocument {
    [key: string]: unknown,
    id: number
    start_period_at: string | null
    end_period_at: string | null
    calculation_type_name: string
    title: string
    fact_shipped: number
    shipment_plan: number
  }

  export interface RewardDocumentDetail {
    [key: string]: unknown,
    contract: RetroBonuses.Contract,
    shipment_plan: number,
    shipment_fact: number,
    percentage_plan_completion: number,
    bonus_total: number,
    product_count: number,
    reward_list: string[],
    start_period_at: string,
    end_period_at: string,
    title: string | null
  }

  export interface RetroScenarios {
    [key: string]: unknown,
    id: number,
    name: string
  }

  export interface Contract {
    [key: string]: unknown,
    number_contract: string,
    date: string,
    id: number
  }

  export interface RewardDocumentsDetail {
    [key: string]: unknown,
    contract: Contract,
    shipment_plan: number,
    shipment_fact: number,
    percentage_plan_completion: number,
    bonus_total: number,
    product_count: number,
    reward_list: string[],
  }

  export interface RewardDocumentProducts {
    [key: string]: unknown,
    id: number
    product_id: number
    product_code: string
    nomenclature: string
    quantity_shipped: string
    reward_amount: string
    revenue_amount: string
  }

  export interface RetroBonusDetail {
    [key: string]: unknown,
    bonus_total: string,
    completion_percentage: string,
    fact_shipped: number,
    id: number,
    max_bonus: string,
    max_plan: string,
    middle_plan: string,
    min_bonus: string,
    min_plan: string,
    quarter: number,
    year: number,
    shipment_plan: number,
    title: string,
    calculation_type: {
      id: number,
      name: string,
      slug: string,
    }
  }
  export interface RetroBonusProducts {
    [key: string]: unknown,
    bonus_per_unit: string,
    bonus_sum: string,
    nomenclature: string,
    product_code: string,
    id: number,
    product_id: number,
    quantity_shipped: number,
  }
}

export interface RetroBonusesFilters extends Filters {
  organizations: string,
  dates: string[],
}

export interface RewardDocumentsFilters extends Filters {
  scenarios: number[],
}

export interface RetroBonusesDetailFilters extends Filters {
  year: number | null,
  quarter: number | null,
}
